import { Component } from '@angular/core';
import { TimelineMax } from 'gsap';
import { IconService } from '../../core/icon.service';
import { params as paramsSocial } from './social.params';
import * as _ from 'lodash';
import {BasicChartComponent} from '../animation-base-classes/basic-chart.component';

@Component({
  selector: 'app-demo-destatis-triptych-line-hor-steps',
  templateUrl: './demo-destatis-triptych-bar-hor-steps.component.html',
  styleUrls: ['./demo-destatis-triptych-bar-hor-steps.component.scss']
})

export class DemoDestatisTriptychLineHorStepsComponent extends BasicChartComponent {

  private slide01Group;
  private slide01ContentGroup;
  private slide02Group;
  private slide02ContentGroup;
  private slide03Group;
  private slide03ContentGroup;

  constructor(
    public iconService: IconService,
  ) {
    super(iconService);
    this.paramObject = {
      'social': paramsSocial,
    };
  }

  public async calculateValues() {
    super.calculateValues();
    this.createBarScales(this.data, this.values);
  }

  public async createElements() {

    this.slide01Group = this.host.select('#slide-01');
    this.slide01ContentGroup = this.host.select('#slide-01-content');
    this.slide01ContentGroup.selectAll('*').remove();
    this.drawTextSlideWithTitle(this.slide01ContentGroup, this.values);

    this.slide02Group = this.host.select('#slide-02');
    this.slide02ContentGroup = this.host.select('#slide-02-content');
    this.slide02ContentGroup.selectAll('*').remove();
    this.drawSlideBarHorSteps(this.slide02ContentGroup, this.values, this.data);

    this.slide03Group = this.host.select('#slide-03');
    this.slide03ContentGroup = this.host.select('#slide-03-content');
    this.slide03ContentGroup.selectAll('*').remove();
    this.drawLogoSlideDestatis(this.slide03ContentGroup, this.values);
  }

  public async createAnimation(noAnimation: boolean = false) {
    let main = new TimelineMax({ repeat: -1 });
    if (!noAnimation) {

      let slide01AnimationTotal = new TimelineMax();

      // slide 1

      let textAnimation = new TimelineMax();
      this.animateText(textAnimation, this.values, this.data);
      slide01AnimationTotal.add(textAnimation);

      let arrowAnimation = new TimelineMax();
      this.animateArrow(arrowAnimation, this.values, this.data);
      slide01AnimationTotal.add(arrowAnimation);

      let pauseSlide1 = new TimelineMax()
        .set({}, {}, 1)
        .duration(this.timings['pauseSlide1']);
      slide01AnimationTotal.add(pauseSlide1);

      let slide1Animation = new TimelineMax();
      slide1Animation.to(this.slide01Group.node(), 1, { x: -this.values['width'] }, 'startSlide01Animation');
      slide01AnimationTotal.add(slide1Animation);

      slide01AnimationTotal.duration(this.timings['slide1Animation']);
      main.add(slide01AnimationTotal);

      // slide 2
      let slide02AnimationTotal = new TimelineMax();
      // let stepsAnimation = new TimelineMax()
      //   .duration(this.timings['animateSteps']);
      // this.animateSteps(stepsAnimation, this.values);
      // slide01AnimationTotal.add(stepsAnimation);

      let barAnimation = new TimelineMax();
      this.animateDestatisBars(barAnimation, this.values, this.data);
      slide02AnimationTotal.add(barAnimation);

      let pauseBar = new TimelineMax()
        .set({}, {}, 'positionForStill')
        .set({}, {}, 1)
        .duration(this.timings['pauseBar']);
      slide02AnimationTotal.add(pauseBar);

      let pauseSlide2 = new TimelineMax()
        .set({}, {}, 1)
        .duration(this.timings['pauseSlide2']);
      slide02AnimationTotal.add(pauseSlide2);
      let slide02Animation = new TimelineMax();
      slide02Animation.duration(this.timings['slide2Animation']);
      slide02Animation.to(this.slide02Group.node(), 1, { x: -this.values['width'] }, 'startSlide02Animation');
      slide02AnimationTotal.add(slide02Animation);
      main.add(slide02AnimationTotal);

      // slide 3
      let slide03AnimationTotal = new TimelineMax();
      // Logo animation
      let logoAnimation = new TimelineMax();
      this.animateDestatisLogo(logoAnimation);
      logoAnimation.duration(this.timings['logoAnimation']);
      slide03AnimationTotal.add(logoAnimation);
      main.add(slide03AnimationTotal);

      let pauseAnimation = new TimelineMax()
        .set({}, {}, 1)
        .duration(this.timings['pauseEnd']);
      main.add(pauseAnimation);
    }

    this.animation = main;
    return this.animation;
  }

  // slide 1
  public drawTextSlideWithTitle(selection, values) {
    this.drawBackgroundDestatis(selection, values, 0);
    // selection.append('text')
    //   .attr('x',  values['marginLeft'] + 2)
    //   .attr('y', values['marginTop'] - 45)
    //   .attr('fill', values['title1Color'])
    //   .attr('text-anchor', 'start')
    //   // .attr('dx', '-0.2em')
    //   .attr('dominant-baseline', 'hanging')
    //   .attr('font-family', 'Arial, Helvetica, sans-serif')
    //   .attr('font-size', 14)
    //   .text('Statistisches Bundesamt');
    this.drawTextTitle(selection, values);
  }

  public drawTextTitle(selection, values) {
    let singleReturn = /\r\n|\n|\f/g;
    let lines = values[`titleText`].split(singleReturn);
    let rowNumber = lines.length;
    let lineHeight = values['textFontSize'] * values['textLineHeight'];
    let height = rowNumber * lineHeight;
    let y =  values['chartDomainY'];
    _.map(lines, (line, index) => {
      let text = selection.append('text')
        .attr('id', 'titelText')
        // .attr('x', values['titleOffsetX'] + values['marginLeft'])
        // .attr('y', values['titleOffsetY'] + values['marginTop'])
        .attr('fill', values['titleColor'])
        .attr('font-family', 'Arial, Helvetica, sans-serif')
        .attr('font-size', values['titleFontSize'])
        .attr('font-weight', values['titleFontWeight'])
        .attr('x', values['titleOffsetX'] + values['marginLeft'] + 2 * values['labelOffsetY'])
        .attr('y', y + index * lineHeight)
        .text(line);
    });
  }

  // slide 2
  public drawSlideBarHorSteps(selection, values, data) {
    this.drawBackgroundDestatis(selection, values, 1);
    this.drawTitleText1(selection, values);
    this.drawTitleText2(selection, values);
    this.drawSteps(selection, values, data);
    this.drawNBars(selection, values, data);
    this.drawXAxisSteps(selection, values, data);
    this.drawDestatisXAxisLabels(selection, values, data);
  }

  public drawTitleText1(selection, values) {
    selection.append('text')
      .attr('x', values['titleOffsetX'] + values['marginLeft'])
      .attr('y', values['title1OffsetY'] + values['marginTop'])
      .attr('fill', values['title1Color'])
      .attr('font-family', 'Arial, Helvetica, sans-serif')
      .attr('font-size', values['title1FontSize'])
      .attr('font-weight', values['titleFontWeight'])
      .text(values['titleText1']);
  }

  public drawTitleText2(selection, values) {
    selection.append('text')
      .attr('x', values['titleOffsetX'] + values['marginLeft'])
      .attr('y', values['title2OffsetY'] + values['marginTop'])
      .attr('fill', values['title2Color'])
      .attr('font-family', 'Arial, Helvetica, sans-serif')
      .attr('font-size', values['title2FontSize'])
      .attr('font-weight', values['titleFontWeight'])
      .text(values['titleText2']);
  }

  public drawNBars(selection, values, data) {
    let barHeights = {};
    let list = _.map(data, a => a[0]);
    let base = null;
    let drawBar = null;
    let dataBar = null;

    dataBar = _.filter(data, function (n) {
      return typeof (n[0]) !== 'string';
    });
    let valuesBar = _.compact(dataBar);
    let g = selection.append('g')
      .attr('id', `legend-${this.id}`);
    let h = v => Math.abs(v * values['chartDomainHeight'] / (values['maxY'] - values['minY']));
    // loop
    for (let idx = 0; idx < valuesBar.length; idx++) {
      if (values['maxY'] < 0) {
        base = values['maxY'];
      } else if (values['minY'] > 0) {
        base = values['minY'];
      } else {
        base = 0;
      }

      _.map(valuesBar[idx], (value, index) => {

        let g1 = selection.append('g')
          .attr('transform', `translate(0, ${this.scaleY(base)})`);
        let g2 = g1.append('g');
        if (value >= base) {
          g2.attr('transform', 'scale(1, -1)');
        }
        let id = `chart-bars-${this.id}-${idx}-${index}`;
        let bar = g2.append('rect')
          .attr('id', id)
          .attr('x', this.scaleX(idx) + index * values['barPaddingInner'])
          .attr('y', 0)
          .attr('width', this.scaleX.bandwidth() / valuesBar[idx].length)
          .attr('height', h(value))
          .attr('fill', values['barColor'][index])
          .attr('data-value', value);
        if (values['barStrokeWidth'] > 0) {
          bar.attr('stroke', values['barStrokeColor']);
          bar.attr('stroke-width', values['barStrokeWidth']);
        } else {
          bar.attr('stroke', 'none');
        }
        let text = g1.append('text')
          .attr('id', `data-label-${this.id}-${idx}-${index}`)
          .attr('text-anchor', 'middle')
          .attr('x', this.scaleX(idx) + index * values['barPaddingInner'] + (this.scaleX.bandwidth() / valuesBar[idx].length / 2))
          .attr('y', - h(value))
          .attr('dy', '-0.3em')
          .attr('alignment-baseline', 'baseline')
          .attr('fill', values['labelColor'])
          .attr('font-size', values['legendFontSize'])
          .attr('font-family', 'Arial, Helvetica, sans-serif')
          .text(this.formatNumberDecimals(value, values['labelDecimalsY'], values['formatLocale']['value']));
      });
    }
    if (values['legend']) {
      _.map(data[0], (dataLabel, index) => {
        let label = dataLabel;
        let offset2ekolom = index % 2 === 0 ? 0 : values['legendSpaceBetweenColumns'];
        let rij = 1;
        if (index > 1) {
          rij = 2;
        }
        let legendItem = g.append('g')
          .attr('id', `legend-${index}-${this.id}`);
        if (typeof label === 'string') {
          let legendLine = legendItem.append('rect')
            .attr('id', `legend-line${index}-${this.id}`)
            .attr('x', values['chartDomainX'] + offset2ekolom)
            .attr('y', values['chartDomainY'] + values['legendOffsetY'] + (rij - 1) * values['legendItemDistance'] - values['legendItemWidth'])
            .attr('width', values['legendItemWidth'])
            .attr('height', values['legendItemWidth'])
            .attr('fill', values['barColor'][index])
            .attr('stroke', 'none')
          let text = legendItem.append('text')
            .attr('id', `legend-label${index}-${this.id}`)
            .attr('text-anchor', 'start')
            .attr('x', values['chartDomainX'] + values['legendItemWidth'] + values['ledgendSpaceBetweenItemAndText'] + offset2ekolom)
            .attr('y', values['chartDomainY'] + values['legendOffsetY'] + (rij - 1) * values['legendItemDistance'])
            .attr('dy', '0.05em')
            .attr('alignment-baseline', 'baseline')
            .attr('fill', values['labelColor'])
            .attr('font-size', values['legendFontSize'])
            .attr('font-family', 'Arial, Helvetica, sans-serif')
            .text(label);
        }
      });
    }
  }

  public drawXAxisSteps(selection, values, data) {
    let g = selection.append('g')

    let xAxis = g.append('line')
      .attr('id', `xAxis-${this.id}`)
      .attr('x1', values['chartDomainX'] - values['axisStrokeWidth'] / 2)
      .attr('x2', values['chartDomainX'] + values['chartDomainWidth'])
      .attr('stroke', values['labelColor'])
      .attr('stroke-width', values['axisStrokeWidth']);
    // If minY is 0 or greater draw the X axis at the bottom
    if (values['minY'] >= 0) {
      xAxis.attr('y1', values['chartDomainY'] + values['chartDomainHeight'])
        .attr('y2', values['chartDomainY'] + values['chartDomainHeight']);
      // If maxY is 0 or less draw the X axis at the top
    } else if (values['maxY'] < 0) {
      xAxis.attr('y1', values['chartDomainY'])
        .attr('y2', values['chartDomainY']);
      // If 0 is between minY and maxY draw a 0 axis
    } else {
      xAxis.attr('y1', this.scaleY(0))
        .attr('y2', this.scaleY(0));
    }

    values['step'] = (values['maxY'] - values['minY']) / (values['steps']);

    let y0Label = values['maxY'] < 0 ? values['maxY'] : values['minY'] > 0 ? values['minY'] : 0;

    // let yLabelAs = g.append('text')
    //   .attr('id', `step-label0-${this.id}`)
    //   .attr('text-anchor', 'end')
    //   .attr('x', values['chartDomainX'] - values['labelOffsetY'])
    //   .attr('y', this.scaleY(y0Label))
    //   .attr('dominant-baseline', 'middle')
    //   .attr('fill', values['labelColor'])
    //   .attr('font-size', values['labelFontSize'])
    //   .attr('font-family', 'Arial, Helvetica, sans-serif')
    // //  .text(this.formatNumberDecimals(y0Label, values['labelDecimalsY'], values['formatLocale']['value']));
    //   .text(y0Label + '%');

  }

  public drawSteps (selection, values, data) {

    let g = selection.append('g');
    let y0Label = values['maxY'] < 0 ? values['maxY'] : values['minY'] > 0 ? values['minY'] : 0;
    values['step'] = (values['maxY'] - values['minY']) / (values['steps']);
    for (let idx: number = 1; idx <= values['steps']; idx++) {
      let yValue;
      let steps = g.append('line')
        .attr('id', `step${idx}-${this.id}`)
        .attr('x1', values['chartDomainX'] - values['axisStrokeWidth'] / 2)
        .attr('x2', values['chartDomainX'] + values['chartDomainWidth'])
        .attr('stroke', values['labelColor'])
        .attr('stroke-width', values['axisStrokeWidth'] - 2)
        .attr('opacity', 0.5);
      // If minY is 0 or greater draw the X axis at the bottom
      if (values['maxY'] <= 0) {
        yValue = - idx * values['step'];
        steps.attr('y1', yValue)
          .attr('y2', yValue);
        // If 0 is between minY and maxY draw a 0 axis
      }
      else if (values['minY'] < 0) {
        yValue = values['minY'] + idx * values['step'] <= y0Label ? - idx * values['step'] : values['minY'] + idx * values['step'];
        steps.attr('y1', this.scaleY(yValue))
          .attr('y2', this.scaleY(yValue));
        // If 0 is between minY and maxY draw a 0 axis
      } else {
        yValue = values['minY'] + idx * values['step'];
        steps.attr('y1', this.scaleY(yValue))
          .attr('y2', this.scaleY(yValue));
      }
      // let label = g.append('text')
      //   .attr('id', `step-label${idx}-${this.id}`)
      //   .attr('text-anchor', 'end')
      //   .attr('x', values['chartDomainX'] - values['labelOffsetY'])
      //   .attr('y', this.scaleY(yValue))
      //   .attr('dominant-baseline', 'middle')
      //   .attr('fill', values['labelColor'])
      //   .attr('font-size', values['labelFontSize'])
      //   .attr('font-family', 'Arial, Helvetica, sans-serif')
      //   .text(yValue + '%')
      //   // .text(this.formatNumberDecimals(yValue, values['labelDecimalsY'], values['formatLocale']['value'], ));
    };
  }

  public drawDestatisXAxisLabels(selection, values, data) {
    let dataAxis = _.filter(data, function (n) {
      return typeof (n[0]) !== 'string';
    });
    let list = _.map(dataAxis, a => a[0]);

    let xAxisLeftLabel = selection.append('text')
      .attr('id', `xAxisLeftLabel-${this.id}`)
      .attr('text-anchor', 'middle')
      .attr('dy', '0.7em')
      .attr('fill', values['labelColor'])
      .attr('font-size', values['labelFontSize'])
      .attr('font-family', 'Arial, Helvetica, sans-serif')
      .text(values['leftLabelX']);
    let xAxisMiddleLabel = selection.append('text')
      .attr('id', `xAxisMiddleLabel-${this.id}`)
      .attr('x', this.scaleX(list.length - 2) + this.scaleX.bandwidth() / 2)
      .attr('text-anchor', 'middle')
      .attr('dy', '0.7em')
      .attr('fill', values['labelColor'])
      .attr('font-size', values['labelFontSize'])
      .attr('font-family', 'Arial, Helvetica, sans-serif')
      .text(values['middleLabelX']);
    let xAxisRightLabel = selection.append('text')
      .attr('id', `xAxisRightLabel-${this.id}`)
      .attr('x', this.scaleX(list.length - 1) + this.scaleX.bandwidth() / 2)
      .attr('text-anchor', 'middle')
      .attr('dy', '0.7em')
      .attr('fill', values['labelColor'])
      .attr('font-size', values['labelFontSize'])
      .attr('font-family', 'Arial, Helvetica, sans-serif')
      .text(values['rightLabelX']);

    let xAxisBottomLabel = selection.append('text')
      .attr('id', `xAxisBottomLabel-${this.id}`)
      .attr('x', this.scaleX(list.length - 2) + this.scaleX.bandwidth() / 2)
      .attr('y', values['chartDomainY'] + values['chartDomainHeight'] + ( 3 * values['labelOffsetX']) + 10)
      .attr('text-anchor', 'middle')
      .attr('dy', '0.7em')
      .attr('fill', values['labelColor'])
      .attr('font-size', values['labelFontSize'])
      .attr('font-family', 'Arial, Helvetica, sans-serif')
      .text(values['labelBottom']);
    // If minY is 0 or greater draw the X axis labels at the bottom
    if (values['minY'] >= 0) {
      xAxisLeftLabel
        .attr('y', values['chartDomainY'] + values['chartDomainHeight'] + values['labelOffsetX'])
        .attr('x', this.scaleX(0) + this.scaleX.bandwidth() / 2);
      xAxisMiddleLabel
        .attr('y', values['chartDomainY'] + values['chartDomainHeight'] + values['labelOffsetX']);
      xAxisRightLabel
        .attr('y', values['chartDomainY'] + values['chartDomainHeight'] + values['labelOffsetX']);
      // If maxY is 0 or less draw the X axis labels at the top
    } else if (values['maxY'] <= 0) {
      xAxisLeftLabel
        .attr('y', values['chartDomainY'] + values['labelOffsetX'])
        .attr('x', this.scaleX(0) + this.scaleX.bandwidth() / 2);
      xAxisMiddleLabel
        .attr('y', values['chartDomainY'] + values['labelOffsetX']);
      xAxisRightLabel
        .attr('y', values['chartDomainY'] + values['labelOffsetX']);
      // If 0 is between minY and maxY draw X axis labels at 0
    } else {
      xAxisLeftLabel
        .attr('y', this.scaleY(0) + values['labelOffsetX'])
        .attr('x', this.scaleX(0) + this.scaleX.bandwidth() / 2);
      xAxisMiddleLabel
        .attr('y', this.scaleY(0) + values['labelOffsetX']);
      xAxisRightLabel
        .attr('y', this.scaleY(0) + values['labelOffsetX']);
      // And a nice 0 at the Y axis
      if (values['drawYAxis']) {
        selection.append('text')
          .attr('id', `zeroValue-${this.id}`)
          .attr('x', values['chartDomainX'] - values['labelOffsetY'])
          .attr('y', this.scaleY(0))
          .attr('text-anchor', 'end')
          .attr('dy', '0.35em')
          .attr('fill', values['labelColor'])
          .attr('font-size', values['labelFontSize'])
          .attr('font-family', 'Arial, Helvetica, sans-serif')
          // .text(values['labelFormatY'] && values['labelFormatY'] !== '' ? numeral(0).format(values['labelFormatY']) : 0)
          .text(this.formatNumberDecimals(0, values['labelDecimalsY'], values['formatLocale']['value'], ));
      }
    }
  }

  // slide 1 en 2
  public drawBackgroundDestatis (selection, values, fillIdx) {

    selection.append('rect')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', values['width'])
      .attr('height', values['height'])
      .attr('fill', '#f4f4f4')
      .attr('stroke', 'none');
    selection.append('rect')
      .attr('x', values['marginLeft'])
      .attr('y', values['marginTop'] - 30)
      .attr('width', values['width'] - (values['marginLeft'] + values['marginRight'] + values['paddingRightTitleLine']) )
      .attr('height', 3)
      .attr('fill', '#ffc20e')
      .attr('stroke', '#ffc20e');
    selection.append('rect')
      .attr('x', values['marginLeft'])
      .attr('y', values['marginTop'] - 31)
      .attr('width', values['width'] - (values['marginLeft'] + values['marginRight'] + values['paddingRightTitleLine']) )
      .attr('height', 1)
      .attr('fill', '#e9e9e8ff')
      .attr('stroke', 'e9e9e8ff');
    selection.append('rect')
      .attr('x', values['marginLeft'])
      .attr('y', values['marginTop'] - 27)
      .attr('width', values['width'] - (values['marginLeft'] + values['marginRight'] + values['paddingRightTitleLine']) )
      .attr('height', 1)
      .attr('fill', '#cececdff');
    selection.append('rect')
      .attr('x', values['width'] - (values['marginLeft'] + values['marginRight']) + 5)
      .attr('y', values['marginTop'] - 30)
      .attr('width', 35 )
      .attr('height', 3)
      .attr('fill', '#ffc20e')
      .attr('stroke', '#ffc20e');
    selection.append('rect')
      .attr('x', values['width'] - (values['marginLeft'] + values['marginRight']) + 5)
      .attr('y', values['marginTop'] - 31)
      .attr('width', 35 )
      .attr('height', 1)
      .attr('fill', '#e9e9e8ff')
      .attr('stroke', 'e9e9e8ff');
    selection.append('rect')
      .attr('x', values['width'] - (values['marginLeft'] + values['marginRight']) + 5)
      .attr('y', values['marginTop'] - 27)
      .attr('width', 35 )
      .attr('height', 1)
      .attr('fill', '#cececdff')
    selection.append('text')
      .attr('x',  values['width'] - (values['marginLeft'] + values['marginRight']))
      .attr('y', values['marginTop'] - 35)
      .attr('fill', values['title1Color'])
      .attr('text-anchor', 'end')
      .attr('dx', '-0.2em')
      .attr('dominant-baseline', 'hanging')
      .attr('font-family', 'Arial, Helvetica, sans-serif')
      .attr('font-size', 12)
      .text('Arbeitsmarkt');
    selection.append('rect')
      .attr('x', values['marginLeft'])
      .attr('y', values['marginTop'])
      .attr('width', values['width'] - (values['marginLeft'] + values['marginRight']) )
      .attr('height', values['height'] - (values['marginTop'] + values['marginBottom']))
      .attr('fill', values['colorScheme']['value'][fillIdx])
      .attr('stroke', 'none');
    selection.append('rect')
      .attr('x', values['marginLeft'])
      .attr('y', values['height'] - values['marginBottom'])
      .attr('width', values['width'] - (values['marginLeft'] + values['marginRight']) )
      .attr('height', 3)
      .attr('fill', '#dcdcdc')
      .attr('stroke', 'none');
    selection.append('rect')
      .attr('x', values['marginLeft'])
      .attr('y', values['height'] - values['marginBottom'] + 3)
      .attr('width', values['width'] - (values['marginLeft'] + values['marginRight']) )
      .attr('height', 1)
      .attr('fill', '#e4e4e4')
      .attr('stroke', 'none');
    selection.append('rect')
      .attr('x', values['marginLeft'])
      .attr('y', values['height'] - values['marginBottom'] + 4)
      .attr('width', values['width'] - (values['marginLeft'] + values['marginRight']) )
      .attr('height', 1)
      .attr('fill', '#eeeeee')
      .attr('stroke', 'none');
  }

  // slide 3
  public drawLogoSlideDestatis(selection, values) {
    this.drawBackgroundLogo(selection, values);
    this.drawDestatisLogo(selection, values);
    this.drawDestatisAdres(selection, values);
    this.drawFooter(selection, values);
  }

  public drawBackgroundLogo (selection, values) {

    selection.append('rect')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', values['width'])
      .attr('height', values['height'])
      .attr('fill', '#FFFFFF')
      .attr('stroke', '#d9e1e9');
  }

  public drawDestatisLogo(selection, values) {
    const logoWidth = 568;
    const logoHeight = 142;
    let factor;
    if (values['destatisLogoWidth']) {
      factor = values['destatisLogoWidth'] / logoWidth;
    } else if (values['destatisLogoHeight']) {
      factor = values['destatisLogoHeight'] / logoHeight;
    } else {
      factor = 1;
    }

    let outerGroup = selection.append('g')
      .attr('id', `destatis-logo-outer-group-${this.id}`)
      .attr('transform', `translate(${values['width'] / 2 - values['destatisLogoWidth'] / 2} ${values['destatisLogoY']})`);
    let innerGroup = outerGroup.append('g')
      .attr('id', `destatis-logo-inner-group-${this.id}`)
      .attr('transform', `scale(${factor} ${factor})`);
    let wissennutzen = innerGroup.append('path')
      .attr('id', `destatis-logo-wissennutzen-${this.id}`)
      // .attr('fill', values['destatisWissenNutzenColor'])
      .attr('fill', '#000000')
      .attr('d', 'M91.1085104,113.66062 L95.4759943,113.66062 L100.643912,135.005166 L100.758715,135.005166 L106.666122,113.66062 L110.184983,113.66062 L116.43113,134.835087 L116.541681,134.835087 L121.369441,113.66062 L125.227042,113.66062 L118.755895,140.682965 L114.66727,140.682965 L108.366202,119.963106 L108.25565,119.963106 L102.348244,140.682965 L98.259973,140.682965 L91.1085104,113.66062 Z M140.66985,113.66062 L144.871862,113.66062 L144.871862,140.6858 L140.66985,140.6858 L140.66985,113.66062 Z M140.390992,101.507067 L145.157807,101.507067 L145.157807,106.619709 L140.390992,106.619709 L140.390992,101.507067 Z M175.078934,118.028104 C174.169366,117.519285 171.385742,115.874835 168.206684,115.874835 C165.768887,115.874835 163.554672,116.894599 163.554672,119.107397 C163.554672,122.345982 167.472865,123.25555 172.184758,126.09445 C174.794052,127.624451 176.838542,129.498507 176.838542,133.300833 C176.838542,137.504262 173.829563,141.308005 166.733376,141.308005 C163.040184,141.308005 160.715418,140.682965 159.406519,140.173083 L159.406519,135.914733 C159.975929,136.254537 163.439869,138.468751 166.957313,138.468751 C170.081095,138.468751 172.635113,137.164104 172.635113,134.101267 C172.635113,131.372918 170.025819,130.293272 166.848179,128.423467 C163.439869,126.434253 159.521323,125.014803 159.521323,120.412398 C159.521323,115.760032 162.645105,113.035935 168.776448,113.035935 C171.615348,113.035935 173.999287,113.771172 175.078934,114.000424 L175.078934,118.028104 Z M202.161161,118.028104 C201.251593,117.519285 198.467969,115.874835 195.288911,115.874835 C192.850759,115.874835 190.636545,116.894599 190.636545,119.107397 C190.636545,122.345982 194.555092,123.25555 199.262379,126.09445 C201.876279,127.624451 203.920414,129.498507 203.920414,133.300833 C203.920414,137.504262 200.911435,141.308005 193.815603,141.308005 C190.122411,141.308005 187.797645,140.682965 186.488746,140.173083 L186.488746,135.914733 C187.058156,136.254537 190.521742,138.468751 194.039186,138.468751 C197.162968,138.468751 199.71734,137.164104 199.71734,134.101267 C199.71734,131.372918 197.107692,130.293272 193.924737,128.423467 C190.521742,126.434253 186.603195,125.014803 186.603195,120.412398 C186.603195,115.760032 189.726977,113.035935 195.858321,113.035935 C198.697221,113.035935 201.081514,113.771172 202.161161,114.000424 L202.161161,118.028104 Z M220.496727,121.436414 C220.496727,119.963106 221.522161,115.305071 226.344606,115.305071 C231.172366,115.305071 231.851264,119.107397 231.851264,121.436414 L220.496727,121.436414 Z M235.71418,137.78879 C234.126069,138.184223 233.216856,138.583554 230.771617,138.583554 C222.426059,138.583554 220.381924,129.898193 220.381924,123.935511 L236.224417,123.935511 C236.224417,121.721296 236.224417,113.035935 226.629488,113.035935 C218.738537,113.035935 215.67003,118.658459 215.67003,126.37508 C215.67003,136.315482 220.951334,141.308005 229.013427,141.308005 C232.081933,141.308005 233.501383,140.853044 235.71418,140.228359 L235.71418,137.78879 Z M249.112853,113.66062 L253.201478,113.66062 L253.201478,120.303264 L253.316282,120.303264 C254.960732,116.894599 257.685183,113.035935 263.021762,113.035935 C267.734719,113.035935 269.494326,117.124206 269.494326,120.133185 L269.494326,140.682965 L265.29515,140.682965 L265.29515,123.196022 C265.29515,120.303264 265.29515,116.49952 261.548454,116.49952 C255.870299,116.49952 253.316282,123.880235 253.316282,129.103428 L253.316282,140.682965 L249.112853,140.682965 L249.112853,113.66062 Z M284.087094,140.682965 L289.763477,140.682965 L289.763477,135.005166 L284.087094,135.005166 L284.087094,140.682965 Z M310.034399,113.66062 L314.123024,113.66062 L314.123024,120.303264 L314.232158,120.303264 C315.882278,116.894599 318.605312,113.035935 323.942954,113.035935 C328.656265,113.035935 330.414455,117.124206 330.414455,120.133185 L330.414455,140.682965 L326.211027,140.682965 L326.211027,123.196022 C326.211027,120.303264 326.211027,116.49952 322.463976,116.49952 C316.786176,116.49952 314.232158,123.880235 314.232158,129.103428 L314.232158,140.682965 L310.034399,140.682965 L310.034399,113.66062 Z M360.390503,134.101267 L360.279952,134.101267 C357.666407,139.663201 355.962075,141.308005 350.570574,141.308005 C346.08687,141.308005 344.097655,136.48556 344.097655,132.96103 L344.097655,113.66062 L348.301084,113.66062 L348.301084,131.147564 C348.301084,134.040322 349.490928,137.844066 353.124592,137.844066 C358.067155,137.844066 360.279952,130.463351 360.279952,125.240158 L360.279952,113.66062 L364.479129,113.66062 L364.479129,140.682965 L360.390503,140.682965 L360.390503,134.101267 Z M390.995844,141.082651 C389.631669,141.308005 388.781629,141.308005 387.642809,141.308005 C382.079458,141.308005 379.581779,139.378319 379.581779,134.495283 L379.581779,116.269914 L374.813547,116.269914 L374.813547,113.66062 L379.581779,113.66062 L379.581779,107.298253 L383.78379,104.745652 L383.78379,113.66062 L391.165922,113.66062 L391.165922,116.269914 L383.78379,116.269914 L383.78379,132.282486 C383.78379,135.459772 383.78379,138.583554 388.437574,138.583554 C389.857024,138.583554 390.481709,138.413475 390.995844,138.243751 L390.995844,141.082651 Z M400.131914,137.844066 L414.2148,116.384717 L401.100655,116.384717 L401.100655,113.66062 L419.327442,113.66062 L419.327442,116.384717 L405.019202,137.673987 L419.497521,137.673987 L419.497521,140.682965 L400.131914,140.682965 L400.131914,137.844066 Z M434.879384,121.436414 C434.879384,119.963106 435.905172,115.305071 440.727262,115.305071 C445.555377,115.305071 446.235338,119.107397 446.235338,121.436414 L434.879384,121.436414 Z M450.098254,137.78879 C448.50908,138.184223 447.599512,138.583554 445.159943,138.583554 C436.808716,138.583554 434.76458,129.898193 434.76458,123.935511 L450.607074,123.935511 C450.607074,121.721296 450.607074,113.035935 441.012145,113.035935 C433.121193,113.035935 430.056939,118.658459 430.056939,126.37508 C430.056939,136.315482 435.33399,141.308005 443.396084,141.308005 C446.46459,141.308005 447.88404,140.853044 450.098254,140.228359 L450.098254,137.78879 Z M461.221767,113.66062 L465.310393,113.66062 L465.310393,120.303264 L465.425196,120.303264 C467.074253,116.894599 469.798349,113.035935 475.136346,113.035935 C479.847885,113.035935 481.607493,117.124206 481.607493,120.133185 L481.607493,140.682965 L477.404419,140.682965 L477.404419,123.196022 C477.404419,120.303264 477.404419,116.49952 473.655951,116.49952 C467.979214,116.49952 465.425196,123.880235 465.425196,129.103428 L465.425196,140.682965 L461.221767,140.682965 L461.221767,113.66062 Z M496.196009,140.682965 L501.872746,140.682965 L501.872746,135.005166 L496.196009,135.005166 L496.196009,140.682965 Z');
    let d_statis = innerGroup.append('path')
      .attr('id', `destatis-logo-d_statis-${this.id}`)
      // .attr('fill', values['destatisLogoColor'])
      .attr('fill', '#A9A9A9')
      .attr('d', 'M567.646146,57.7921887 C567.646146,66.042786 564.4926,72.1301926 558.181611,76.0639753 C551.874519,79.9924431 543.098449,81.9557912 531.858715,81.9557912 C525.431505,81.9557912 520.014139,81.6315783 515.597048,80.981381 C511.178541,80.3364985 507.530703,79.5222459 504.652118,78.541812 L504.652118,65.3188878 C506.900348,66.49881 510.433383,67.5883778 515.241654,68.5868826 C520.053824,69.587159 524.782725,70.091372 529.440406,70.091372 C535.981356,70.091372 540.489155,69.3320407 542.953882,67.8020394 C545.417545,66.2777074 546.651326,63.7293589 546.651326,60.1608914 C546.651326,57.9126612 546.02664,55.7774626 543.988174,54.148603 C542.044669,52.5902552 532.847653,50.0911587 524.537528,47.2522587 C517.914727,44.883556 512.797833,41.8944197 509.17409,38.2820151 C505.546095,34.6681933 503.736881,29.7451184 503.736881,23.5035778 C503.736881,17.546565 506.660821,12.5033719 512.512951,8.37506141 C518.359413,4.25277456 527.016782,2.17887522 537.33561,2.01871761 C543.37341,1.9237569 550.595384,2.53285189 554.593301,3.21848237 C558.586611,3.90836483 561.39433,4.51745982 563.013623,5.05179097 L563.013623,17.0522733 C559.625155,16.336879 556.267515,15.7075871 552.924402,15.1523505 C549.585187,14.5985311 543.768489,13.8675462 539.994509,13.8675462 C534.646592,13.8675462 529.06517,14.8522321 526.366585,16.4711704 C524.227489,17.752077 523.003275,19.679992 522.827527,21.7893244 C522.568511,24.8677521 523.713,26.6372812 525.482529,28.0368886 C527.255956,29.440748 532.447968,31.5203167 541.069904,34.2826811 C549.095147,36.8129588 558.976375,40.1659931 562.539174,43.9031221 C565.982917,47.5229676 567.646146,52.4244283 567.646146,57.7921887 Z M469.084372,81.4515782 L489.264586,81.4515782 L489.264586,3.86726243 L469.084372,3.86726243 L469.084372,81.4515782 Z M455.590739,15.4528231 L436.229385,15.4528231 L436.229385,81.4515782 L416.049171,81.4515782 L416.049171,15.4528231 L396.143919,15.4528231 L396.143919,3.86301046 L455.590739,3.86301046 L455.590739,15.4528231 Z M347.296556,51.7246246 L357.571446,23.1279869 L368.516376,51.7246246 L347.296556,51.7246246 Z M368.986928,3.86301046 L350.255928,3.86301046 L320.249762,81.4515782 L336.62198,81.4515782 L343.348245,62.9048307 L372.775081,62.9048307 L379.336936,81.4515782 L399.881048,81.4515782 L368.986928,3.86301046 Z M322.75311,15.4273113 L303.387504,15.4273113 L303.387504,81.4203971 L283.20729,81.4203971 L283.20729,15.4273113 L263.302038,15.4273113 L263.302038,3.83749863 L322.75311,3.83749863 L322.75311,15.4273113 Z M258.363727,57.7723461 C258.363727,66.0229435 255.205929,72.11035 248.899191,76.0384635 C242.58643,79.9669313 233.816029,81.9302794 222.576296,81.9302794 C216.149086,81.9302794 210.727467,81.6060665 206.308959,80.9615384 C201.896121,80.316656 198.248284,79.5024034 195.369698,78.5219695 L195.369698,65.2933759 C197.617929,66.4732982 201.146711,67.562866 205.954628,68.56704 C210.767152,69.5673165 215.500306,70.0658602 220.152317,70.0658602 C226.694331,70.0658602 231.20213,69.3065288 233.671462,67.7821969 C236.129456,66.2578649 237.364654,63.7095164 237.364654,60.1367969 C237.364654,57.8871494 236.744221,55.7579744 234.705754,54.1287605 C232.756225,52.5704127 223.565233,50.0713162 215.255109,47.2267469 C208.632308,44.8580442 203.509745,41.8703252 199.887419,38.2565033 C196.263321,34.6483507 194.454462,29.7213782 194.454462,23.4837353 C194.454462,17.5210532 197.378401,12.4792774 203.224862,8.35521888 C209.076993,4.23293202 217.728693,2.15336339 228.048938,1.99320577 C234.085321,1.90391436 241.307295,2.50875738 245.304858,3.19863984 C249.302774,3.882853 252.11191,4.49761728 253.726951,5.03194843 L253.726951,17.0267614 C250.342736,16.3170364 246.979426,15.6877446 243.641982,15.1325079 C240.297098,14.5772712 234.486069,13.8434517 230.71209,13.8434517 C225.364172,13.8434517 219.777081,14.8281376 217.078142,16.4470759 C214.944715,17.7265652 213.715186,19.6558975 213.540855,21.7638126 C213.286091,24.8479096 214.424911,26.6117693 216.198692,28.0170461 C217.967867,29.4152362 223.161296,31.4990568 231.781815,34.2628386 C239.808475,36.787447 249.687932,40.1465049 253.256754,43.8832796 C256.700497,47.4974558 258.363727,52.4003338 258.363727,57.7723461 Z M89.4438634,81.5961452 L178.697008,81.5961452 L178.697008,68.2088114 L89.4438634,68.2088114 L89.4438634,81.5961452 Z M51.7228481,64.474517 C48.844263,68.0826696 44.55048,69.8862144 38.8344123,69.8862144 L20.8825865,69.8862144 L20.8825865,12.3885687 L36.8451981,12.3885687 C42.6817383,12.3885687 47.9545379,14.2782159 51.3433596,18.7704243 C54.7360789,23.268302 57.6203333,29.9761422 57.8499397,40.2056781 C57.8499397,40.2056781 57.9250579,41.8646559 57.864113,44.3637524 C57.5792309,54.6032097 54.6014331,60.8663644 51.7228481,64.474517 Z M76.6659788,38.6714249 C76.2053485,28.5666134 73.047905,17.4813681 67.270538,10.8089611 C61.4935254,4.13797132 51.9028482,0.798755972 38.4985065,0.798755972 L0.722215605,0.7236378 L0.716546309,81.4756727 L42.1477615,81.4756727 C53.3818258,81.4756727 61.867699,78.4227568 67.6050265,72.325429 C73.3366848,66.2224318 76.4307031,56.4535261 76.745349,45.1429263 C76.745349,45.1429263 76.890979,43.669618 76.6659788,38.6714249 Z');
    let black = innerGroup.append('polygon')
      .attr('id', `destatis-logo-black-${this.id}`)
      .attr('fill', '#000')
      .attr('points', '90.375 61.56 90.379 9.221 109.055 9.221 109.055 61.545');
    let red = innerGroup.append('polygon')
      .attr('id', `destatis-logo-red-${this.id}`)
      .attr('fill', '#D00')
      .attr('points', '124.378 61.545 124.383 21.475 143.058 21.475 143.07 61.56');
    let yellow = innerGroup.append('polygon')
      .attr('id', `destatis-logo-yellow-${this.id}`)
      .attr('fill', '#FFCE00')
      .attr('points', '159.132 61.57 159.132 2.129 177.813 2.129 177.813 61.551');
    return outerGroup;
  }

  public drawDestatisAdres(selection, values) {

    selection.append('text')
      .attr('id', `twitter-${this.id}`)
      .attr('x', values['width'] / 2)
      .attr('y', values['destatisLogoY'] + 120)
      .attr('text-anchor', 'middle')
      .attr('fill', values['labelColor'])
      .attr('font-size', values['labelFontSize'])
      .attr('font-family', 'Arial, Helvetica, sans-serif')
      .attr('opacity', 0.8)
      .text('@destatis');
    selection.append('text')
      .attr('id',  `website-${this.id}` )
      .attr('x', values['width'] / 2)
      .attr('y', values['destatisLogoY'] + 150)
      .attr('text-anchor', 'middle')
      .attr('fill', values['labelColor'])
      .attr('font-size', values['labelFontSize'])
      .attr('font-family', 'Arial, Helvetica, sans-serif')
      .attr('opacity', 0.8)
      .text('www.destatis.de');
  }

  public drawFooter(selection, values) {

    selection.append('text')
      .attr('id', `footer-${this.id}`)
      .attr('x', values['width'] -  values['marginRight'])
      .attr('y', values['height'] - ( values['marginBottom'] / 2))
      .attr('text-anchor', 'end')
      .attr('fill', values['labelColor'])
      .attr('font-size', 14)
      .attr('font-family', 'Arial, Helvetica, sans-serif')
      .attr('opacity', 0.8)
      .text('Statistisches Bundesamt, 2018');
    let factor = 0.2;
    let outerGroup = selection.append('g')
      .attr('id', `destatis-logo-outer${this.id}`)
      .attr('transform', `translate(${ values['width'] -  values['marginRight'] - 235} ${values['height'] - ( values['marginBottom'] / 2) - 15})`);
    let innerGroup = outerGroup.append('g')
      .attr('id', `destatis-logo-inner-group-${this.id}`)
      .attr('transform', `scale(${factor} ${factor})`);
   let d_statis = innerGroup.append('path')
      .attr('id', `destatis-logo-d-${this.id}`)
      // .attr('fill', values['destatisLogoColor'])
      .attr('fill', '#A9A9A9')
      .attr('d', ' M89.4438634,81.5961452 L178.697008,81.5961452 L178.697008,68.2088114 L89.4438634,68.2088114 L89.4438634,81.5961452 Z');
    let black = innerGroup.append('polygon')
      .attr('id', `destatis-logo-b-${this.id}`)
      .attr('fill', '#000')
      .attr('points', '90.375 61.56 90.379 9.221 109.055 9.221 109.055 61.545');
    let red = innerGroup.append('polygon')
      .attr('id', `destatis-logo-r-${this.id}`)
      .attr('fill', '#D00')
      .attr('points', '124.378 61.545 124.383 21.475 143.058 21.475 143.07 61.56');
    let yellow = innerGroup.append('polygon')
      .attr('id', `destatis-logo-y-${this.id}`)
      .attr('fill', '#FFCE00')
      .attr('points', '159.132 61.57 159.132 2.129 177.813 2.129 177.813 61.551');
  }

  // animation slide 1
  public animateText(timeline, values, data) {
    timeline.fromTo('#titelText', 0.1, {attr: {opacity: 0}}, {attr: {opacity: 1}}, 'startTitle');
    return timeline;
  }

  public animateArrow(timeline, values, data) {
    timeline.fromTo('#path3761', 0.1, {attr: {opacity: 0}}, {attr: {opacity: 1}}, 'startTitle');
    timeline.fromTo('#path3759', 0.1, {attr: {opacity: 0}}, {attr: {opacity: 1}}, 'startArrow2');
    timeline.fromTo('#path2987', 0.1, {attr: {opacity: 0}}, {attr: {opacity: 1}}, 'startArrow3');
    return timeline;
  }

  // animation slide 2
  public animateDestatisBars(timeline, values, data) {
    for (let idx = 1; idx <= values['steps'] && values['steps']; idx++) {
      timeline.fromTo(`#step${idx}-${this.id}`, 0.1, {
          attr: {
            y1: this.scaleY(values['minY'] + (idx - 1) * values['step']),
            y2: this.scaleY(values['minY'] + (idx - 1) * values['step']),
            opacity: 0
          }
        }, { attr: { y1: this.scaleY(values['minY'] + idx * values['step']), y2: this.scaleY(values['minY'] + idx * values['step']), opacity: 0.5 } }, 'startstep')
    }

    for (let idx1 = data[0].length - 1 ; idx1 >= 0 ; idx1--) {
      for (let idx2 = 0; idx2 < data.length; idx2++) {
        timeline.from(`#chart-bars-${this.id}-${idx2}-${idx1}`, 0.1, {attr: {height: '0'}}, `bar${idx1}`);
        timeline.from(`#data-label-${this.id}-${idx2}-${idx1}`, 0.1, {opacity: 0}, `data${idx1}`);
      }
      timeline.fromTo(`#legend-${idx1}-${this.id}`, 0.1, { opacity: 0 }, { opacity: 1 }, `data${idx1}`);
    }
    return timeline; }

  public animateSteps(timeline, values) {
    let maxAnimationSteps = 50; // bij meer dan 50 steps, worden deze niet meer geanimeerd
    timeline.fromTo(`#xAxis-${this.id}`, 0.1, { attr: { opacity: 0 } }, { attr: { opacity: 1 } }, 'startXAxes')
      .fromTo(`#xAxisLeftLabel-${this.id}`, 0.1, { attr: { opacity: 0 } }, { attr: { opacity: 1 } }, 'startXAxes')
      .fromTo(`#xAxisMiddleLabel-${this.id}`, 0.1, { attr: { opacity: 0 } }, { attr: { opacity: 1 } }, 'startXAxes')
      .fromTo(`#xAxisRightLabel-${this.id}`, 0.1, { attr: { opacity: 0 } }, { attr: { opacity: 1 } }, 'startXAxes')
      .fromTo(`#xAxisBottomLabel-${this.id}`, 0.1, { attr: { opacity: 0 } }, { attr: { opacity: 1 } }, 'startXAxes')
      .fromTo(`#step-label0-${this.id}`, 0.5, { attr: { opacity: 0 } }, { attr: { opacity: 1 } }, `startXAxes`);

    // if (values['maxY'] <= 0) {
    //   for (let idx = 1; idx <= values['steps'] && values['steps'] < maxAnimationSteps; idx++) {
    //     timeline.fromTo(`#step-label${idx}-${this.id}`, 1, { attr: { y: this.scaleY(-(idx - 1) * values['step']), opacity: 0 } }, { attr: { y: this.scaleY(- idx * values['step']), opacity: 1 } }, idx, 'startXAxes')
    //       .fromTo(`#step${idx}-${this.id}`, 1, {
    //         attr: {
    //           y1: this.scaleY(-(idx - 1) * values['step']),
    //           y2: this.scaleY(-(idx - 1) * values['step'])
    //         }
    //       }, { attr: { y1: this.scaleY(- idx * values['step']), y2: this.scaleY(- idx * values['step']) } }, idx, 'startXAxes')
    //   }
    // } else if (values['minY'] < 0) {
    //   let y0Label = values['maxY'] < 0 ? values['maxY'] : values['minY'] > 0 ? values['minY'] : 0;
    //   for (let idx = 1; idx <= values['steps'] && values['steps'] < maxAnimationSteps; idx++) {
    //     let yValue = values['minY'] + idx * values['step'] <= y0Label ? - idx * values['step'] : values['minY'] + idx * values['step'];
    //     timeline.fromTo(`#step-label${idx}-${this.id}`, 1, { attr: { y: this.scaleY(0), opacity: 0 } }, { attr: { y: this.scaleY(yValue), opacity: 1 } }, idx, 'startXAxes')
    //       .fromTo(`#step${idx}-${this.id}`, 1, {
    //         attr: {
    //           y1: this.scaleY(0),
    //           y2: this.scaleY(0)
    //         }
    //       }, { attr: { y1: this.scaleY(yValue), y2: this.scaleY(yValue) } }, idx, 'startXAxes')
    //   }
    // } else {
    //   for (let idx = 1; idx <= values['steps'] && values['steps'] < maxAnimationSteps; idx++) {
    //     timeline.fromTo(`#step-label${idx}-${this.id}`, 1, {
    //       attr: {
    //         y: this.scaleY(values['minY'] + (idx - 1) * values['step']),
    //         opacity: 0
    //       }
    //     }, { attr: { y: this.scaleY(values['minY'] + idx * values['step']), opacity: 1 } }, idx, `startstep${idx}`)
    //       .fromTo(`#step${idx}-${this.id}`, 1, {
    //         attr: {
    //           y1: this.scaleY(values['minY'] + (idx - 1) * values['step']),
    //           y2: this.scaleY(values['minY'] + (idx - 1) * values['step']),
    //           opacity: 0
    //         }
    //       }, { attr: { y1: this.scaleY(values['minY'] + idx * values['step']), y2: this.scaleY(values['minY'] + idx * values['step']), opacity: 0.5 } }, idx, `startstep${idx}`)
    //   }
    // }
  }

  // animation slide 3
  public animateDestatisLogo(timeline) {
    timeline.from(`#destatis-logo-wissennutzen-${this.id}`, 2, { scale: 3, x: '-=400'}, 'animatePayoff');
    timeline.from(`#destatis-logo-d_statis-${this.id}`, 1, { opacity: 0 , delay: 2}, 'animateLogo');
    timeline.from(`#destatis-logo-black-${this.id}`, 1, { fill: '#A9A9A9', scaleY: 0, transformOrigin: '50% 100%' }, 'animateFillColor');
    timeline.from(`#destatis-logo-red-${this.id}`, 1, { fill: '#A9A9A9', scaleY: 0, transformOrigin: '50% 100%' }, 'animateFillColor');
    timeline.from(`#destatis-logo-yellow-${this.id}`, 1, { fill: '#A9A9A9', scaleY: 0, transformOrigin: '50% 100%' }, 'animateFillColor');
    timeline.from(`#twitter-${this.id}`, 1, { opacity: 0 , delay: 2}, 'animateAdres');
    timeline.from(`#website-${this.id}`, 1, { opacity: 0 , delay: 2}, 'animateAdres');
  }
}



// WEBPACK FOOTER //
// ./src/app/animations/demo-destatis-triptych-bar-hor-steps/demo-destatis-triptych-bar-hor-steps.component.ts